import { useDispatch } from "react-redux";
import { appointmentsApi } from "../api";

export const useResetAppointmentsState = () => {
  const dispatch = useDispatch();

  return () => dispatch(appointmentsApi.util.resetApiState());
};
